import { render, staticRenderFns } from "./account_menu.vue?vue&type=template&id=ab4dbc30&scoped=true"
import script from "./account_menu.vue?vue&type=script&lang=js"
export * from "./account_menu.vue?vue&type=script&lang=js"
import style0 from "./account_menu.vue?vue&type=style&index=0&id=ab4dbc30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab4dbc30",
  null
  
)

export default component.exports